function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExit = function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 19.226"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c43975b0",
    transform: "translate(-295 -386.774)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 295,
    y: 386.775,
    width: 22,
    height: 19.225,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#c43975b0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.153,404.046a1.309,1.309,0,0,1-1.707,1.286l-6.1-1.462a2.249,2.249,0,0,1-1.724-2.043v-12.76a1.792,1.792,0,0,1,1.821-1.668h13.03a1.7,1.7,0,0,1,1.717,1.668v3.419m-3.372,3.5H317m-5.689-2.5-2.49,2.5,2.49,2.252m-8.422-1.668v1.668m-7.264-9.18a1.231,1.231,0,0,1,1.6-1.286l6.578,1.462a1.508,1.508,0,0,1,1.346,1.678v13.351m7.04-5.108v2.669a1.7,1.7,0,0,1-1.717,1.668h-4.738",
    transform: "translate(-295 -386.774)",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  })));
};
export default SvgExit;